import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';


import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';


export const JobApprovalTickets = gql`
  query JobApprovalTickets($jobId: Int!) {
    all_tickets(job_id: $jobId) {
      edges {
        node {
          id
          state
          ticketNumber: ticket_number {
            id
            number
            document {
              id
            }
          }
        }
      }
    }
    job(job_id: $jobId) {
      id
      hasTimeEntries: has_time_entries
      mutable
      pdf_path
      all_reviewed
    }
  }
`;


const withData = graphql(JobApprovalTickets);


const mapDataToProps = withProps((props) => {
  const { data } = props;
  const tickets = querySelector(data, '$.all_tickets.edges[*].node', []);
  const { job } = data;
  return {
    tickets,
    job,
  };
});


const enhance = compose(
  withData,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);


export default enhance;
